import PropTypes from 'prop-types';
import Checkbox from "components/form/Checkbox/Checkbox";
import { useHistory } from "react-router-dom";

function Facet({ label, count, active, url }) {
  const history = useHistory();

  const handleChange = () => {
    const searchParams = new URLSearchParams(new URL(url).searchParams);
    searchParams.delete('_format'); // remove the _format from the string (this will break viewing the page otherwise)
    history.push('?' + searchParams.toString());
  }

  return (
    <Checkbox label={ `${ label }` }
              onChange={ handleChange }
              checked={ active }>
      { label } ({ count })
    </Checkbox>
  );
}

Facet.propTypes = {
  label: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  active: PropTypes.bool,
  url: PropTypes.string.isRequired,
}

export default Facet;
